module.exports = __webpack_public_path__ + "img/problem_cover_04.980edf72.jpg";